import React from "react";
import { sortByOrderAscending } from "../../helper/helper";
const HopperRestaurantAboutusPage = ({ components }) => {
    const getLeftComponents = (component) => {
        switch (component.ID) {
            case "HopperRestaurantAboutusPage-left-subheader":
                return <div className="HopperRestaurantAboutusPage-left-subheader">
                    {component?.Props?.text}
                </div>
            case "HopperRestaurantAboutusPage-left-header":
                return <div className="HopperRestaurantAboutusPage-left-header">
                    {component?.Props?.text}
                </div>
            case "HopperRestaurantAboutusPage-left-mob-img":
                return <img className="HopperRestaurantAboutusPage-left-img"
                    src={component?.Props?.src} />
            case "HopperRestaurantAboutusPage-left-content":
                return <div className="HopperRestaurantAboutusPage-left-content">
                    {component?.Props?.text} </div>
            case "HopperRestaurantAboutusPage-left-det":
                return <div className="HopperRestaurantAboutusPage-left-flex">
                    {component?.Data?.map((cont, key) => {
                        return (
                            <div className="HopperRestaurantAboutusPage-left-flex-item"
                                key={key}>
                                <div className="HopperRestaurantAboutusPage-left-flex-item-header">{cont?.header}</div>
                                <div className="HopperRestaurantAboutusPage-left-flex-item-subheader">{cont?.subheader}</div>
                            </div>
                        )
                    })}
                </div>
            default:
                return <div />
        }

    }
    const getLeftContent = (components) => {
        return (
            <div className="HopperRestaurantAboutusPage-right">
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getLeftComponents(component)
                    )
                })}
            </div>
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "HopperRestaurantAboutusPage-left":
                return getLeftContent(component?.Components)
            case "HopperRestaurantAboutusPage-right":
                return <div className="HopperRestaurantAboutusPage-right">
                    <img className="HopperRestaurantAboutusPage-right-img"
                        src={component?.Props?.src} />
                </div>
            default:
                return <div />
        }

    }
    return (
        <div className="HopperRestaurantAboutusPage">

            {sortByOrderAscending(components).map((component, key) => {
                return (
                    getComponents(component)
                )
            })}
        </div>
    )
}
export default HopperRestaurantAboutusPage